<template>
  <div class="wrapper">
    <div>
      <a-skeleton
        class="loading-details-skeleton"
        v-if="loading"
        :avatar="{ shape: 'circle' }"
        :paragraph="false"
        :active="true"
      />
      <page-header v-else :avatar="avatar" :title="title" />
    </div>

    <header-tabs :selectedKeys="selectedKeys" :routes="routes" />

    <div class="content">
      <router-view :instance="instance" />
    </div>
  </div>
</template>

<script>
import HeaderTabs from '@/views/Layouts/HeaderTabsContent/HeaderTabs'

export default {
  components: {
    HeaderTabs
  },
  data() {
    return {
      instance: null,
      loading: false
    }
  },
  methods: {
    fetchDetails() {
      if (this.service == null) {
        return
      }

      this.loading = true
      this.service
        .get(this.params)
        .then(res => {
          this.instance = res.data
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    params: {
      handler(value) {
        if (!value) {
          return
        }
        this.fetchDetails()
      },
      immediate: true
    }
  },
  computed: {
    service() {
      return null
    },
    title() {
      return 'Tytuł'
    },
    routes() {
      return []
    },
    avatar() {
      return this.instance && this.instance.avatar
    },
    selectedKeys() {
      const currentRoute = this.$route.path
      const currentKey = this.routes.findIndex(route =>
        currentRoute.startsWith(route.to)
      )
      return currentKey !== undefined ? [currentKey] : []
    },
    params() {
      return this.$route.params.lecturerId
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-details-skeleton {
  height: 64px;
  display: flex;
  align-items: center;
}
</style>
